"use client";

import dynamic from "next/dynamic";
import type { Locale } from "@/lib/i18n/config";
import type { PassedStudent } from "@/lib/content/passed-students";

// Lazy-load slider chunk — den er below-the-fold på de fleste viewports
// og indeholder en del client-side logik (auto-rotate, drag, modulo-loop).
// ssr: false betyder at den IKKE bundles i initial JS payload.
const PassedStudentsSlider = dynamic(
  () => import("./PassedStudentsSlider").then((m) => ({ default: m.PassedStudentsSlider })),
  {
    ssr: false,
    loading: () => (
      <section
        className="pt-12 lg:pt-16 pb-16 lg:pb-20"
        style={{ background: "linear-gradient(180deg, #fff 0%, var(--color-green-soft) 100%)" }}
      >
        <div className="container-wide">
          <div className="text-center max-w-[620px] mx-auto mb-6 lg:mb-8 min-h-[140px]" />
          <div className="relative max-w-[880px] mx-auto" style={{ minHeight: "min(60vh, 506px)" }} />
        </div>
      </section>
    ),
  }
);

type Props = {
  locale: Locale;
  students: PassedStudent[];
};

export function PassedStudentsSliderLazy(props: Props) {
  return <PassedStudentsSlider {...props} />;
}
